import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const StarHalfFilledGlyph = /*#__PURE__*/createElement("g", {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    transform: 'scale(4)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M17.0898 6.29439L12.2498 5.87439L10.3598 1.42439C10.0198 0.614395 8.85977 0.614395 8.51977 1.42439L6.62977 5.88439L1.79977 6.29439C0.91977 6.36439 0.55977 7.46439 1.22977 8.04439L4.89977 11.2244L3.79977 15.9444C3.59977 16.8044 4.52977 17.4844 5.28977 17.0244L9.43977 14.5244L13.5898 17.0344C14.3498 17.4944 15.2798 16.8144 15.0798 15.9544L13.9798 11.2244L17.6498 8.04439C18.3198 7.46439 17.9698 6.36439 17.0898 6.29439ZM9.43977 12.6544V3.35439L11.1498 7.39439L15.5298 7.77439L12.2098 10.6544L13.2098 14.9344L9.43977 12.6544Z",
  fill: "currentColor"
}));
const StarHalfFilled = createSvg({
  name: 'star',
  path: StarHalfFilledGlyph
});

export default StarHalfFilled;
export { StarHalfFilledGlyph };
